<template>
  <div class="cancellation-policy-note" :class="{ desktop: $isDesktop }">
    <pu-popover>
      <template #trigger>
        <translate>Cancellation policy</translate>
        <img
          loading="lazy"
          src="@/assets/images/info.svg"
          width="21"
          height="21"
          alt=""
        />
      </template>
      <template #content>
        <translate tag="h3" :tt="{ campsiteName: campsiteName }">
          {campsiteName} cancellation policy
        </translate>
        <div v-html="campsiteCancellationPolicy" />
      </template>
    </pu-popover>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CancellationPolicyPopover extends Vue {
  @Prop({ required: true, type: String })
  campsiteName: string

  @Prop({ required: true, type: String })
  campsiteCancellationPolicy: string
}

export default toNative(CancellationPolicyPopover)
</script>
<style scoped>
.cancellation-policy-note {
  background: white;
  border-radius: 0.5em;
  margin: 0.75em 0 0;
  padding: 0.5em 0.8em;
  min-height: 2.5em;
}

.cancellation-policy-note :deep(.pu-popover) {
  display: block;
}

.cancellation-policy-note :deep(.info-button) {
  width: 100%;
  text-align: left;
}

.cancellation-policy-note :deep(.info-button span) {
  font-size: var(--body);
  color: var(--colour-dark-blue);
}

.cancellation-policy-note :deep(.info-button img) {
  vertical-align: text-bottom;
}

.desktop.cancellation-policy-note :deep(.info-button span) {
  font-size: initial;
}
</style>
